import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { WebApiService } from 'src/app/shared';
import { OfferSection, Product } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class OperationSectionService extends WebApiService {
  private readonly operationServicesUrl = `${this.catalogUrl}/operationservices`;
  private readonly itServicesUrl = `${this.catalogUrl}/itservices`;
  private readonly csOperationUrl = 'csoperation';
  private readonly itServicesSectionUrl = 'itservices';

  constructor(protected http: HttpClient, protected snackBar: MatSnackBar) {
    super(http, snackBar);
  }

  public getOperationAndMaintenanceServices(): Observable<ReadonlyArray<Product>> {
    return this.http.get<Product[]>(`${this.operationServicesUrl}`, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }

  public getItServices(): Observable<ReadonlyArray<Product>> {
    return this.http.get<Product[]>(`${this.itServicesUrl}`, { responseType: 'json' })
      .pipe(this.handleApiRequest());
  }


  public addOperationAndMaintenanceSection(projectId: Guid, newOperationAndMaintenanceSection: OfferSection): Observable<OfferSection> {
    return this.post(projectId, this.csOperationUrl, newOperationAndMaintenanceSection);
  }

  public getOperationAndMaintenanceSection(projectId: Guid): Observable<OfferSection> {
    return this.get(projectId, this.csOperationUrl);
  }

  public updateOperationAndMaintenanceSection(projectId: Guid, updatedOperationAndMaintenanceSection: OfferSection)
    : Observable<OfferSection>
  {
    return this.put(projectId, this.csOperationUrl, updatedOperationAndMaintenanceSection);
  }

  public deleteOperationAndMaintenanceSection(projectId: Guid): Observable<OfferSection> {
    return this.delete(projectId, this.csOperationUrl);
  }


  public addItSection(projectId: Guid, newItSection: OfferSection): Observable<OfferSection> {
    return this.post(projectId, this.itServicesSectionUrl, newItSection);
  }

  public getItSection(projectId: Guid): Observable<OfferSection> {
    return this.get(projectId, this.itServicesSectionUrl);
  }

  public updateItSection(projectId: Guid, updatedItSection: OfferSection): Observable<OfferSection> {
    return this.put(projectId, this.itServicesSectionUrl, updatedItSection);
  }

  public deleteItSection(projectId: Guid): Observable<OfferSection> {
    return this.delete(projectId, this.itServicesSectionUrl);
  }
}
